import { render } from "./MemberColumn.vue?vue&type=template&id=6f5d93da&scoped=true"
import script from "./MemberColumn.vue?vue&type=script&lang=js"
export * from "./MemberColumn.vue?vue&type=script&lang=js"

import "./MemberColumn.vue?vue&type=style&index=0&id=6f5d93da&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5d93da"]])

export default __exports__